import { render, staticRenderFns } from "./StartTrainingSection.vue?vue&type=template&id=46a32550&scoped=true&"
import script from "./StartTrainingSection.vue?vue&type=script&lang=ts&"
export * from "./StartTrainingSection.vue?vue&type=script&lang=ts&"
import style0 from "./StartTrainingSection.vue?vue&type=style&index=0&id=46a32550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a32550",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default})
